import { data } from '../../svg/Login/data';
import { makeIcon } from '../makeIcon';

export const Login = makeIcon(data, 'login', 'Login');

export default Login;
